module.exports = __webpack_public_path__ + "img/button-s_pow21.ec0fc2e.png";